import React, { useEffect, useState } from "react";
import LoadingScreen from "../screens/generic-screens/loading/LoadingScreen";
import { useNavigate } from "react-router-dom";
import LS_CONSTANTS from "../../constants/LSConstants";
import { getHourDiff } from "../../funcs/TimeFuncs";
import { clearAllLSData } from "../../funcs/LSFuncs";
import notify from "../../funcs/ToastFuncs";
import APP_CONSTANTS from "../../constants/AppConstants";
const LOADING_DELAY_MS = 1000;

function RequireAuth({ children }) {
  const [renderComponenet, setRenderComponenet] = useState(<LoadingScreen />);
  const navigate = useNavigate();
  useEffect(() => {
    const navToLogin = () => {
      navigate("/login", {
        state: { redirectInfo: window.location.pathname },
        replace: true,
      });
    };

    const timeoutId = setTimeout(() => {
      const userData = JSON.parse(
        localStorage.getItem(LS_CONSTANTS.LS_USER_DATA)
      );
      const userSessionData = JSON.parse(
        localStorage.getItem(LS_CONSTANTS.LS_USER_SESSION_DATA)
      );
      if (
        !userData ||
        userData.access_token === undefined ||
        !userSessionData ||
        userSessionData.loggedInTime === undefined
      ) {
        navToLogin();
      } else {
        //check session expiry and redirect to login if required
        const lastLoggedInhours = getHourDiff(
          userSessionData.loggedInTime,
          undefined,
          "hours"
        );

        if (
          Math.abs(lastLoggedInhours) > APP_CONSTANTS.USER_SESSION_LIMIT_HRS
        ) {
          notify("Session expired! Please login.", "warning", false);
          clearAllLSData();
          navToLogin();
        } else {
          setRenderComponenet(children);
        }
      }
    }, LOADING_DELAY_MS);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [navigate, children]);

  return renderComponenet;
}

export default RequireAuth;
